import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/app/(marketing)/_PageSections/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible","CollapsibleTrigger","CollapsibleContent"] */ "/vercel/path0/src/components/ui/Collapsible.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/Sidebar.tsx");
